import * as React from 'react';
import NovidadesService from '../../services/NovidadesService';

import { formatDateWithHour } from '../../utils/time';
import { useDebounce } from '@base/react';
import { DEFAULT_VALUE_SELECIONE } from './novidades';

import columns from './columns';

let cancel = null;

export default (props) => {
  const [data, setData] = React.useState([]);
  const [typeScreen, setTypeScreen] = React.useState(1);
  const [isLoading, setIsLoading] = React.useState(true);
  const [error, setError] = React.useState(false);
  const [time, setTime] = React.useState('');
  const [isCPF, setIsCPF] = React.useState(false);
  const [isCNPJ, setIsCNPJ] = React.useState(false);
  const [isALL, setIsALL] = React.useState(true);
  const [allValuesOptions, setAllValuesOptions] = React.useState([]);
  const [cidades, setCidades] = React.useState([]);
  const [downloadedSheet, setDownloadedSheet] = React.useState(null);
  const [downloadingSheet, setIsDownloadingSheet] = React.useState(false);
  const [firstRender, setFirstRender] = React.useState(true);
  const [actionDone, setActionDone] = React.useState(false);
  const [cnaesFiltered, setCnaesFiltered] = React.useState([]);
  const [subMenusFiltered, setSubMenusFiltered] = React.useState([]);
  const [selectedRow, setSelectedRow] = React.useState(null);
  const [aprovationValue, setAprovationValue] = React.useState({});

  const updateFilter = (state, action) => {
    switch (action.type) {
      case 'linesPerPage':
        return { ...state, linesPerPage: action.data };
      case 'page':
        return { ...state, page: action.data };
      case 'order':
        return { ...state, order: action.data };
      case 'filters':
        return { ...state, filters: action.data };
      case 'clean':
        return { ...action.data };
      default:
        throw new Error();
    }
  };

  const initialValueFilter = {
    filters: {},
    linesPerPage: 10,
    page: 0,
    order: {
      name: 'id',
      orderType: false,
    },
  };

  const [filters, setFilters] = React.useReducer(
    updateFilter,
    initialValueFilter
  ); // filter values to send
  const [filtersSelectedValues, setFiltersSelectedValues] = React.useState(); // filter values from each ref
  const [filterOptions, setFiltersOptions] = React.useState({}); // all filter options get from API
  const filterTerm = useDebounce(filtersSelectedValues?.oqueVoceProcura, 500);

  const getCidades = async (id) => {
    updateSelectedValues('ufs', id);

    if (id !== DEFAULT_VALUE_SELECIONE) {
      const uf = filterOptions.ufs.find((u) => u.id === parseInt(id));
      const cidadesByUF = filterOptions.cidades.filter(
        (cd) => cd.uf.id === parseInt(id)
      );

      setFilters({
        type: 'filters',
        data: {
          ...filters.filters,
          ufs: [uf],
        },
      });
      setCidades(cidadesByUF ?? []);
    } else {
      setFilters({
        type: 'filters',
        data: { ...filters.filters, ufs: null, cidades: null },
      });
      setCidades([]);
    }
  };

  const cleanFilters = () => {
    const backupVal = { ...filters.filters };
    const tmp = Object.keys(backupVal)
      .filter((val) => {
        const value = Array.isArray(backupVal[val])
          ? backupVal[val][0]
          : backupVal[val];
        // if (tipo === 1) return (value && value !== DEFAULT_VALUE_SELECIONE && val !== 'segmentos' && val !== 'cnaes' && val !== 'portes');
        return !!value && value !== DEFAULT_VALUE_SELECIONE;
      })
      .reduce((res, key) => {
        return {
          ...res,
          [key]: backupVal[key],
        };
      }, {});

    return tmp;
  };

  const cleanSelectedFilters = () => {
    setCidades([]);
    setFiltersSelectedValues({});
  };

  const trateColumns = () => {
    const values = [...(columns ?? [])].filter((cl) => cl?.field !== 'status');
    return values;
  };

  const downloadFile = async () => {
    setIsDownloadingSheet(true);
    const response = await NovidadesService.buscarDiagnosticos(
      `?linesPerPage=${filters.linesPerPage}&page=${filters.page}&orderBy=${
        filters.order.name
      }&direction=${filters.order.orderType ? 'ASC' : 'DESC'}`,
      cleanFilters(),
      updateCancel
    );
    setDownloadedSheet(response?.data);
    setIsDownloadingSheet(false);
  };

  const updateCancel = (c) => {
    cancel = c;
  };

  const tratedCols = trateColumns();

  const trateExcelData = () => {
    const tmp = [];

    // Avoiding subfiels, making a 1 lvl object to generate a sheet
    downloadedSheet.content &&
      downloadedSheet.content.forEach((tm, index) => {
        tratedCols.forEach((td) => {
          const field = td?.field;
          const subfield = td?.subfield;
          if (field === 'uf') {
            tmp[index] = { ...tmp[index], sigla: tm[field]?.[subfield] };
          } else if (field === 'imagem') {
            tmp[index] = { ...tmp[index], imagem: tm[field]?.urlConteudo };
          } else if (field === 'versao') {
            tmp[index] = { ...tmp[index], versao: tm[field]?.android };
          } else {
            tmp[index] = {
              ...tmp[index],
              [subfield ?? field]: tm?.[field]?.[subfield] ?? tm?.[field] ?? '',
            };
          }
        });
      });

    return tmp;
  };

  const deleteNotificacao = async (idDiagnostico) => {
    const responseDelete = await NovidadesService.deleteDiagnostico(
      idDiagnostico
    );
    return responseDelete;
  };

  const updateStatusNotification = async (idDiagnostico, status) => {
    const responseUpdate = await NovidadesService.updateStatus(
      idDiagnostico,
      status
    );
    return responseUpdate;
  };

  const updateSelectedValues = (nameFilter, value) =>
    setFiltersSelectedValues({
      ...(filtersSelectedValues ?? {}),
      [nameFilter]: value,
    });

  const getData = async () => {
    setIsLoading(true);
    const response = await NovidadesService.buscarDiagnosticos(
      `?linesPerPage=${filters.linesPerPage}&page=${filters.page}&orderBy=${
        filters.order.name
      }&direction=${filters.order.orderType ? 'ASC' : 'DESC'}`,
      {
        ...cleanFilters(),
        tipoPessoa: isCPF
          ? 'PESSOA_FISICA'
          : isCNPJ
          ? 'PESSOA_JURIDICA'
          : 'TODAS',
      }
    );
    const respOptions = await NovidadesService.getOptions();
    const respOptionsOptimized = await NovidadesService.getOptions(true);
    const analytics = await NovidadesService.getAnalytics().then((response) => {
      return response.data;
    });
    const respPendenteValue = analytics?.pendente;
    const respAprovadoValue = analytics?.aprovado;
    if (
      response?.status === 200 &&
      respOptions?.status === 200 &&
      respOptionsOptimized.status === 200
    ) {
      setFirstRender(false);
      setData(response?.data);
      setAllValuesOptions(respOptions?.data);
      setFiltersOptions(respOptionsOptimized?.data ?? []);
      setAprovationValue({
        PENDENTE: respPendenteValue ?? 0,
        APROVADO: respAprovadoValue ?? 0,
      });
      setTime(formatDateWithHour());
    } else {
      setError(true);
    }
    setFirstRender(false);
    setIsLoading(false);
    setActionDone(false);
  };

  // prettier-ignore
  React.useEffect(_ => {
    // Cancelando a requisição do XLS quando alterar filtro
    if (cancel) cancel();
    setDownloadedSheet(null);
    if (filters.page === 0 && !firstRender) {
      getData();
    } else {
      setFilters({ type: 'page', data: 0 })
      setFiltersSelectedValues({
        ...filtersSelectedValues, page: 1
      })
    }

    // https://github.com/facebook/create-react-app/issues/6880
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [filters.filters, filters.linesPerPage, filters.order, filters.orderType]);

  // prettier-ignore
  React.useEffect(_ => {

    getData();

    // https://github.com/facebook/create-react-app/issues/6880
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [filters.page]);

  // prettier-ignore
  React.useEffect(_ => {
    if (!firstRender)
      setFilters({ type: 'filters', data: { ...filters.filters, oqueVoceProcura: filterTerm } })

    // https://github.com/facebook/create-react-app/issues/6880
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [filterTerm])

  // prettier-ignore
  React.useEffect(_ => {
    if (actionDone && !firstRender) {
      cleanSelectedFilters()
      setFilters({ type: 'filters', data: {} })
    }

    // https://github.com/facebook/create-react-app/issues/6880
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [actionDone]);

  return {
    data,
    isLoading,
    error,
    typeScreen,
    setTypeScreen,
    filters,
    setFilters,
    isCPF,
    isCNPJ,
    isALL,
    setIsCPF,
    setIsCNPJ,
    setIsALL,
    selectedRow,
    setSelectedRow,
    allValuesOptions,
    filtersSelectedValues,
    updateSelectedValues,
    deleteNotificacao,
    setActionDone,
    updateStatusNotification,
    filterOptions,
    getCidades,
    cidades,
    trateExcelData,
    cnaesFiltered,
    setCnaesFiltered,
    subMenusFiltered,
    setSubMenusFiltered,
    cleanSelectedFilters,
    time,
    downloadingSheet,
    downloadedSheet,
    downloadFile,
    tratedCols,
    aprovationValue,
  };
};
